import React from "react"
import OurEnvironmentAfter1 from '../../../assets/OurEnvironmentAfter1.jpg';
import OurEnvironmentBefor1 from '../../../assets/OurEnvironmentBefor1.png';
import OurEnvironmentAfter2 from '../../../assets/OurEnvironmentAfter2.png';
import OurEnvironmentBefor2 from '../../../assets/OurEnvironmentBefor2.png';
import './ourEnvironment.css';
import { useSelector} from 'react-redux'
import { useState,useEffect } from "react";

function OurEnvironment () {

    let boolean = useSelector((state) => state.boolean.bool)
    let [texte,setTexte]=useState()
    let [titre,setTitre]=useState()

    useEffect(() => {
      // Update the document title using the browser API
      if(boolean===false){
        setTexte(texteFR)
        setTitre(titreFR)
     }
     else{
      setTexte(texteANG)
      setTitre(titreENG)
     }
     console.log(texte)
    });

    //le textes en deux langues
    let texteFR="Nous prenons soin de notre environnement de travail. Nos chantiers sont toujours maintenus propres, sans déchets ni encombrements, et nous éliminons tous les matériaux selon les règles en vigueur. Nous limitons au maximum notre impact sur l’environnement tout en faisant attention aux autres professionnels qui travaillent sur le même site. La sécurité compte autant pour nous : nous formons notre équipe à respecter strictement les mesures et normes de sécurité afin de protéger nos collaborateurs et toutes les personnes présentes sur le chantier. Ces habitudes nous permettent de mener nos projets de façon responsable, tant sur le plan environnemental que sur le plan sécuritaire.";
    let texteANG="We take great care of our work environment. Our work sites are always kept clean, without waste or clutter, and we dispose of all materials in accordance with current regulations. We do our utmost to limit our environmental impact while being considerate of other professionals working on site. Safety matters just as much to us: we train our team to strictly comply with safety measures and standards in order to protect our employees and everyone present on the site. These habits allow us to carry out our projects in an environmentally responsibly and safe manner.";

    let titreFR= "Durabilité et sécurité en premier"
    let titreENG= "Sustainability and Safety First"

  return (
    <section className="ourEnvironmentSection">
      <div className="ourEnvironmentGlobalDiv">

        <h3 className="ourLeadershipTitle">{titre}</h3>

        <div className="ourEnvironmentDiv">

          <div className="ourEnvironmentText">
            <p>{texte}</p>
          </div>

          <div className="GlobalOurEnvironmentPictures">
              <img src={OurEnvironmentAfter1} className="OurEnvironmentPicture" alt="" />
              <img src={OurEnvironmentBefor1} className="OurEnvironmentPicture" alt="" />
            
              <img src={OurEnvironmentAfter2} className="OurEnvironmentPicture" alt="" />
              <img src={OurEnvironmentBefor2} className="OurEnvironmentPicture" alt="" />    
          </div>

        </div>

      </div>
      
    </section>
  )
}

export default OurEnvironment;
